export const IA_CREDIT_OPERATIONAL_ALERTS = {
  operationConflict: { threshold: 0, windowMinutes: 15, action: "investigate_uuid_payload_reuse" },
  releaseRatio: { thresholdPercent: 20, windowMinutes: 30, action: "investigate_provider_failures" },
  oldestReservation: { maxAgeMinutes: 20, action: "run_reconciler" },
  ledgerHistoryDivergence: { threshold: 0, action: "block_rollout" },
  legacyChatWithoutProtocol: { target: 0, stableHours: 72, action: "hold_until_zero" },
} as const

type OperationalEvent = {
  event: "ia_credit_denied" | "ia_credit_legacy_compat"
  operationId?: string
  userId?: string
  status: "denied" | "without_protocol"
  durationMs?: number
  source: "chat_activity"
}

export function emitIACreditOperationalEvent(event: OperationalEvent): void {
  const monitor = event.event === "ia_credit_legacy_compat"
    ? "legacyChatWithoutProtocol"
    : "operationConflict"
  console.warn(JSON.stringify({
    ...event,
    monitor,
    alert: IA_CREDIT_OPERATIONAL_ALERTS[monitor],
  }))
}
